import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import config from '@/config/index'
const service = axios.create({
  baseURL: config.apiRequestUrl,
  timeout: 20000,
})
service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      if (config.method == 'get') {
        if (!config.params) {
          config.params = {}
        }
        config.params.accToken = getToken()
      }
      if (config.method == 'post') {
        if (!config.data) {
          config.data = {}
        }
        config.data.accToken = getToken()
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000,
      })
      if (res.code == 99) {
        return res
      }
      if (res.code === 1 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('您登录的网站已离线，您是否重新登录？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      // 取消跳入reject
      // return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    Message({
      message: '网络异常，请您检查是否可以上网？',
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  }
)

export default service
